<template>
  <modal ref='import'>
    <template #header>
      <h5 class="modal-title mt-0">{{$t('checklist.import.header')}}</h5>
    </template>

    <template #body>
      <form @submit.prevent='parseOrImportCSV($event)' @reset='clearImportData'>
        <div class="modal-body">
          <div class="form-group">
            <input type="file" name="file" class="form-control" accept="plain/text, text/csv" />
          </div>

          <p>
            {{$t('checklist.import.download')}}
            <a href="/checklists-template.csv">
              {{$t('checklist.import.template_info_text_for_checklist')}}
            </a>
          </p>

          <div v-if='dataToImport.errors.length'>
            {{$t('checklist.import.total_errors', {errors: dataToImport.errors.length})}}
          </div>

          <div v-if='dataToImport.errors.length'>
            <ul>
              <li v-for='error in dataToImport.errors.slice(0, 5)'>
                {{ error }}
              </li>
            </ul>
          </div>

          <p v-if='dataToImport.progress'>
            <strong>{{$t('checklist.import.progress')}}:</strong>
             {{ dataToImport.progress }}%
          </p>

          <p v-if='dataToImport.data.length'>
            <strong>{{$t('checklist.import.total_items')}}</strong>
             {{ dataToImport.data.length }}
          </p>

          <table v-if='dataToImport.data.length' class="table">
            <thead>
              <th>{{$t('checklist.import.product_name')}}</th>
              <th>{{$t('checklist.import.product_code')}}</th>
              <th>{{$t('checklist.import.document_type')}}</th>
            </thead>

            <tbody>
              <tr v-for='row in dataToImport.data.slice(0, 5)'>
                <td v-for='cell in row.slice(0, 3)'>
                  {{ cell }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div  class='modal-footer'>
          <input v-if='dataToImport.isParsing' type='reset' :value="$t('checklist.import.reset')" class="btn btn-outline-primary">
          <input v-if='dataToImport.progress === 100' type='submit' :value="$t('checklist.import.import')" class="btn btn-primary">
          <input v-else type='submit' :value="$t('checklist.import.preview')" class="btn btn-primary">
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
  import _modal from '../_modal'
  import Papa from 'papaparse'

  export default {
    components: {
      'modal': _modal,
    },
    props: {
      extraParams: {
        type: Object,
        default: () => { return {} }
      }
    },
    data() {
      return {
        dataToImport: {
          data: [],
          errors: [],
          progress: null,
          isParsing: false
        }
      }
    },
    methods: {
      open() {
        this.$refs.import.open()
      },
      close() {
        this.clearImportData()
        this.$refs.import.close()
      },
      parseOrImportCSV(event) {
        if (this.dataToImport.progress === 100) {
          this.importCSV()
        } else {
          this.parseCSV(event)
        }
      },
      parseCSV(event) {
        let file = new FormData(event.target).get('file')

        if (file && file.size === 0)
          return

        this.dataToImport.isParsing = true

        Papa.parse(file, {
          worker: true,
          skipEmptyLines: true,
          step: (results) => {
            this.dataToImport.data.push(Object.values(results.data))
            this.dataToImport.progress = results.meta.cursor / file.size * 100
            this.dataToImport.errors = results.errors.map(({message}) => message)
          },
          complete: () => {
            this.dataToImport.progress = 100
          }
        })
      },
      clearImportData() {
        this.dataToImport = {
          data: [],
          errors: [],
          progress: null,
          isParsing: false
        }
      },
      importCSV() {
        let params = {
          checklist_items: this.dataToImport.data.map(([product_name, product_code, document_type_name]) => {
            return {
              product: { name: product_name, code: product_code },
              document_type: { name: document_type_name },
              checklist_item: Object.assign({}, this.$props.extraParams)
            }
          })
        }

        this.store.createChecklistItemsBulk(params).then(({data}) => {
          this.store.sendMetrics({name: 'import_checklist_from_csv', params: this.$route.params, path: this.$route.fullPath})
          this.store.getChecklistItems({ 'filters[folder_id_eq]': this.$props.extraParams.folder_id })

          let message = `We imported ${data.success} checklist items`

          if (data.failures > 0)
            message += ` but ${data.failures} failed`

          this.$toastr.success(message)
        })

        this.close()
        this.$toastr.success('We started importing your checklist items')
      }
    }
  }
</script>
